import {Pipe, PipeTransform} from '@angular/core';
import {BookingChangeService} from "../../core/services/booking-change.service";

@Pipe({
  name: 'bookingChangeInProgress',
  pure: false
})
export class BookingChangeInProgressPipe implements PipeTransform {

  constructor(private bookingChange: BookingChangeService) {
  }

  transform(args: any): boolean {
    return this.bookingChange.bookingChangeInProgress;
  }

}
